import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContentCallOut.module.scss';
import cx from 'classnames';
import {
    ALIGNMENT_OPTIONS,
    HEADING_LEVELS,
    HEADING_STYLES,
    ICON_POSITION,
    ICON_SIZES,
} from '../../../lib/constants';
import { Heading, Icon } from '../../index';
import { getIconUrl } from '../../../lib/helpers/mediaHeplers';

const ContentCallOut = (props) => {
    const {
        title,
        headingLevel,
        horizontalAlignment,
        children,
        icon,
        iconPosition,
        iconAltText,
        overrideStyle,
        iconSize,
    } = props;

    const classes = cx(
        styles[`card--alignment-${horizontalAlignment}`],
        `card--text-align-${horizontalAlignment}`,
        'card light-theme'
    );

    return (
        <div className={cx(styles.card)}>
            <div
                className={cx(
                    styles['icon-container'],
                    styles[`icon-container--align-${iconPosition}`]
                )}
            >
                <Icon
                    className={cx(styles.icon)}
                    size={iconSize}
                    altText={iconAltText}
                    url={getIconUrl(icon)}
                />
            </div>
            <div className={classes}>
                <Heading
                    color="darkPurple"
                    text={title}
                    headingLevel={headingLevel}
                    hideFromTableOfContent={true}
                    className={cx(styles['title'])}
                    overrideStyle={overrideStyle}
                />
                {children}
            </div>
        </div>
    );
};

ContentCallOut.displayName = 'Card';

ContentCallOut.propTypes = {
    horizontalAlignment: PropTypes.oneOf(ALIGNMENT_OPTIONS).isRequired,
    title: PropTypes.string.isRequired,
    headingLevel: PropTypes.oneOf(HEADING_LEVELS).isRequired,
    overrideStyle: PropTypes.oneOf(HEADING_STYLES).isRequired,
    icon: PropTypes.string.isRequired,
    iconAltText: PropTypes.string.isRequired,
    iconPosition: PropTypes.oneOf(ICON_POSITION).isRequired,
    iconSize: PropTypes.oneOf(ICON_SIZES).isRequired,
};

ContentCallOut.defaultProps = {
    horizontalAlignment: 'left',
};

export default ContentCallOut;
